import React, { useState } from "react";
import {
  View,
  Text,
  StyleSheet,
  Modal,
  Pressable,
  ScrollView,
  ViewStyle,
  StyleProp,
} from "react-native";

type DropdownProps = {
  label: string;
  value: string;
  options: string[];
  onChange: (newValue: string) => void;
  style?: StyleProp<ViewStyle>;
};

export default function Dropdown({
  label,
  value,
  options,
  onChange,
  style,
}: DropdownProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <View style={[styles.wrapper, style]}>
      <Text style={styles.label}>{label}</Text>

      <Pressable
        onPress={() => setIsOpen(true)}
        style={({ pressed }) => [
          styles.field,
          pressed && { borderColor: "#1e88e5" },
        ]}
      >
        <Text style={styles.valueText}>{value}</Text>
        <Text style={styles.caret}>▾</Text>
      </Pressable>

      <Modal
        transparent
        visible={isOpen}
        animationType="fade"
        onRequestClose={() => setIsOpen(false)}
      >
        <Pressable style={styles.overlay} onPress={() => setIsOpen(false)} />
        <View style={styles.menuContainer}>
          <View style={styles.menuCard}>
            <Text style={styles.menuTitle}>{label}</Text>

            <ScrollView style={{ maxHeight: 280 }}>
              {options.map((optionValue) => (
                <Pressable
                  key={optionValue}
                  onPress={() => {
                    onChange(optionValue);
                    setIsOpen(false);
                  }}
                  style={({ pressed }) => [
                    styles.menuItem,
                    pressed && { backgroundColor: "#eef5ff" },
                    optionValue === value && {
                      borderColor: "#1e88e5",
                      borderWidth: 1,
                      backgroundColor: "#f4f8ff",
                    },
                  ]}
                >
                  <Text
                    style={[
                      styles.menuItemText,
                      optionValue === value && {
                        color: "#1e88e5",
                        fontWeight: "700",
                      },
                    ]}
                  >
                    {optionValue}
                  </Text>
                </Pressable>
              ))}
            </ScrollView>

            <Pressable style={styles.closeBtn} onPress={() => setIsOpen(false)}>
              <Text style={styles.closeText}>Close</Text>
            </Pressable>
          </View>
        </View>
      </Modal>
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: { flex: 1, marginRight: 8 },
  label: { fontSize: 12, color: "#666", marginBottom: 6, marginLeft: 4 },
  field: {
    height: 44,
    backgroundColor: "#fff",
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#ddd",
    paddingHorizontal: 12,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  valueText: { fontSize: 16, color: "#333" },
  caret: { fontSize: 16, color: "#666" },

  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(0,0,0,0.25)",
  },
  menuContainer: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    justifyContent: "center",
    alignItems: "center",
    padding: 24,
  },
  menuCard: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: "#fff",
    borderRadius: 12,
    padding: 16,
  },
  menuTitle: {
    fontSize: 16,
    fontWeight: "700",
    marginBottom: 12,
    color: "#333",
  },
  menuItem: {
    paddingVertical: 12,
    paddingHorizontal: 12,
    borderRadius: 8,
    marginBottom: 6,
    backgroundColor: "#fff",
  },
  menuItemText: { fontSize: 16, color: "#333" },
  closeBtn: {
    alignSelf: "flex-end",
    backgroundColor: "#1e88e5",
    paddingVertical: 10,
    paddingHorizontal: 14,
    borderRadius: 8,
    marginTop: 10,
  },
  closeText: { color: "#fff", fontWeight: "700" },
});
